<template>
  <li class="menu-item">
    <a href="#" @click.stop="click"><t-icon name="icon-settings" /></a>
    <ul class="sub-menu-items" ref="submenu" :style="submenuStyle">
      <li class="sub-menu-item">
        <a href="#" @click.prevent="toggleSpread" :title="spread ? 'Vis enkeltside' : 'Vis oppslag'">
          <t-icon v-if="!spread" name="icon-spread" />
          <t-icon v-else name="icon-page-right" />
        </a>
      </li>
      <li class="sub-menu-item">
        <a @click.prevent="toggleFullscreen" href="#" :title="fullscreen ? 'Gå ut av fullskjerm' : 'Gå til fullskjerm'">
          <t-icon v-if="!fullscreen" name="icon-enter-full-screen" />
          <t-icon v-else name="icon-exit-full-screen" />
        </a>
      </li>
      <li class="sub-menu-item">
        <a href="#" @click.stop="click"><t-icon name="icon-settings" /></a>
      </li>
    </ul>
  </li>
</template>

<script>
import uiUtil from '@/utils/ui'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      open: false,
      rootEl: null
    }
  },
  mounted () {
    this.rootEl = this.$el
  },
  created () {
    document.addEventListener('click', this.clickoutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickoutside)
  },
  methods: {
    ...mapActions(['setSpread', 'enterFullscreen', 'exitFullscreen']),
    click (event) {
      event.preventDefault()
      this.open = !this.open
    },
    clickoutside (event) {
      uiUtil.clickOutside(event, this.$refs.submenu, clickOutside => {
        if (this.open && clickOutside) {
          this.open = false
        }
      })
    },
    toggleSpread () {
      this.setSpread(!this.spread)
    },
    toggleFullscreen () {
      if (this.fullscreen) {
        this.exitFullscreen()
      } else {
        this.enterFullscreen()
      }
    }
  },
  computed: {
    ...mapGetters(['fullscreen', 'spread']),
    submenuStyle () {
      return {
        'min-width': `${(3 * 55)}px`
      }
    },
    ...mapGetters(['oddPage', 'evenPage'])
  },
  watch: {
    open (newVal) {
      this.$el.classList.toggle('open')
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/MenuItemSettings.vue